import { Component, Inject, OnInit } from '@angular/core';
import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar";
import {CommonDataService} from "../../common/common-data.service";
import {Expiry} from "./link-expiry-error";

@Component({
  selector: 'link-expiry-error',
  templateUrl: './link-expiry-error.component.html',
  styleUrls: ['./link-expiry-error.component.scss']
})
export class LinkExpiryErrorComponent implements OnInit {

  constructor(public commonDataService: CommonDataService, @Inject(MAT_SNACK_BAR_DATA) public data: Expiry) { }

  ngOnInit() {}

}
